<card class="card my-2 mx-auto w-70">
    <div>

        <mat-form-field class="input-field">
            <mat-label>Enter Project Code</mat-label>
            <input matInput name="projectCode" [(ngModel)]="projectCode" />
        </mat-form-field>

        <button class="btn btn-primary" (click)="fetchData()" [disabled]="!projectCode || isLoading" data-cy="fetch-records">Fetch Data</button>

        <ng-container *ngIf="isLoading; else contentTemplate">
            <div class="main-div">
                <h5>Fetching Data</h5>
                <br><br>
                <div class="dots-spinner">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </div>
        </ng-container>

        <ng-template #contentTemplate>
            <div *ngIf="reportAnalysis?.length > 0 && dataFetched ;else noData" class="table-container">
                <div class="selection-controls" style="display: flex; gap: 20px; margin-bottom: 10px;">
                    <mat-checkbox (change)="onCheckboxChange('All', $event.checked)"
                        [checked]="selectedOption === 'All'">
                        Select All
                    </mat-checkbox>

                    <mat-checkbox (change)="onCheckboxChange('Pass', $event.checked)"
                        [checked]="selectedOption === 'Pass'" [disabled]="disablePassCheckbox">
                        Select All Pass
                    </mat-checkbox>

                    <mat-checkbox (change)="onCheckboxChange('Fail', $event.checked)"
                        [checked]="selectedOption === 'Fail'" [disabled]="disableFailCheckbox">
                        Select All Fail
                    </mat-checkbox>
                </div>

                <mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort id="htmlData1">
                    <ng-container matColumnDef="select">
                        <mat-header-cell *matHeaderCellDef>Select</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <mat-checkbox [(ngModel)]="row.flag"
                                (change)="onRowCheckboxChange(row, $event.checked)"></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Project_Code">
                        <mat-header-cell *matHeaderCellDef>Project Code</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.project_code}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Target_Name">
                        <mat-header-cell *matHeaderCellDef>Target Name</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.target}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Run_ID">
                        <mat-header-cell *matHeaderCellDef> Run ID</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.run_id}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="analysisDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> RedThread Analysis Date(UTC)
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.analysis_date}}</mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="UserName">
                        <mat-header-cell *matHeaderCellDef> User Name </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.username}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="RunStatus">
                        <mat-header-cell *matHeaderCellDef> Run Status </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.run_status}}</mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: tableColumns;"></mat-row>
                </mat-table>
                <button class="btn btn-primary" (click)="submitData()" style="margin-top:15px;"
                    [disabled]="selectedRows.length===0 || isSubmitted" data-cy="submit-btn">Submit</button>
                <span *ngIf="isSubmitted === true">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Processing...
                </span>
                <div class="alert alert-danger " *ngIf="!submitStatus && submitMessage!==''">
                    {{submitMessage}}
                </div>
                <mat-paginator #RApaginator [length]="reportAnalysis.length" [pageSizeOptions]="[ 10, 20]"
                    showFirstLastButtons></mat-paginator>

            </div>

            <ng-template #noData>
                <p *ngIf="reportAnalysis?.length === 0 && dataFetched" class="no-data">No data found for this project
                    code.</p>
            </ng-template>
        </ng-template>
    </div>
</card>